"use strict";
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabPanel = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var React = tslib_1.__importStar(require("react"));
var common_1 = require("../../common");
var tabTitle_1 = require("./tabTitle");
/**
 * Wraps the passed `panel`.
 */
var TabPanel = /** @class */ (function (_super) {
    tslib_1.__extends(TabPanel, _super);
    function TabPanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabPanel.prototype.render = function () {
        var _a = this.props, className = _a.className, id = _a.id, parentId = _a.parentId, selectedTabId = _a.selectedTabId, panel = _a.panel, renderActiveTabPanelOnly = _a.renderActiveTabPanelOnly;
        var isSelected = id === selectedTabId;
        if (panel === undefined || (renderActiveTabPanelOnly && !isSelected)) {
            return undefined;
        }
        var _b = (0, tabTitle_1.generateTabIds)(parentId, id), tabTitleId = _b.tabTitleId, tabPanelId = _b.tabPanelId;
        return (React.createElement("div", { "aria-labelledby": tabTitleId, "aria-hidden": !isSelected, className: (0, classnames_1.default)(common_1.Classes.TAB_PANEL, className), id: tabPanelId, role: "tabpanel" }, common_1.Utils.isFunction(panel) ? panel({ tabPanelId: tabPanelId, tabTitleId: tabTitleId }) : panel));
    };
    return TabPanel;
}(common_1.AbstractPureComponent));
exports.TabPanel = TabPanel;
//# sourceMappingURL=tabPanel.js.map